/** Libellés LOT OPS — pas d’enums bruts côté UI. */

export function frGpsStatus(status: string | undefined, reason: string | undefined): string {
  const base =
    status === "OK"
      ? "GPS conforme"
      : status === "MISSING"
        ? "GPS manquant"
        : status === "PARTIAL"
          ? "GPS partiel"
          : status === "SUSPECT"
            ? "GPS suspect"
            : "GPS";

  if (reason === "DISTANCE_TOO_HIGH") return `${base} (écart lieu/client)`;
  if (reason === "GPS_START_MISSING") return "GPS début manquant";
  if (reason === "GPS_END_MISSING") return "GPS fin manquant";
  if (reason === "CLIENT_LOCATION_MISSING") return "Réf. client absente (GPS)";
  if (reason === "INVALID_COORDINATES") return `${base} (coordonnées invalides)`;
  return base;
}
